type OakStreamTraceEntry = {
  time: string;
  area: string;
  event: string;
  details: Record<string, unknown>;
};

type OakStreamTraceWindow = Window & {
  __oakStreamTrace?: OakStreamTraceEntry[];
  __oakStreamTraceDump?: () => OakStreamTraceEntry[];
  __oakStreamTraceClear?: () => void;
};

const TRACE_LIMIT = 500;

function getWindowObject() {
  if (typeof window === "undefined") {
    return undefined;
  }

  return window as OakStreamTraceWindow;
}

function isTraceEnabled() {
  const win = getWindowObject();
  if (!win) {
    return false;
  }

  return (
    win.localStorage.getItem("oak:stream-debug") === "1" ||
    win.localStorage.getItem("scout:debug") === "1" ||
    new URLSearchParams(win.location.search).get("streamDebug") === "1" ||
    new URLSearchParams(win.location.search).get("scoutDebug") === "1"
  );
}

function ensureTraceBuffer(win: OakStreamTraceWindow) {
  if (!win.__oakStreamTrace) {
    win.__oakStreamTrace = [];
    win.__oakStreamTraceDump = () => [...(win.__oakStreamTrace ?? [])];
    win.__oakStreamTraceClear = () => {
      win.__oakStreamTrace = [];
    };
  }

  return win.__oakStreamTrace;
}

export function traceOakStream(area: string, event: string, details: Record<string, unknown>) {
  if (!isTraceEnabled()) {
    return;
  }

  const win = getWindowObject();
  if (!win) {
    return;
  }

  const entry: OakStreamTraceEntry = {
    time: new Date().toISOString(),
    area,
    event,
    details,
  };
  const buffer = ensureTraceBuffer(win);
  buffer.push(entry);
  if (buffer.length > TRACE_LIMIT) {
    buffer.splice(0, buffer.length - TRACE_LIMIT);
  }

  console.debug(`[OakStream:${area}] ${event}`, details);
}
